/* tslint:disable:no-unused-variable member-ordering */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ParamCeInterface} from '../../../models/ce/param-ce.interface';
import {OauthService} from '../../oauth.service';
import {Http} from '@angular/http';
import {App} from 'ionic-angular';
import {ToolsService} from '../../tools.service';
import {AppProvider} from "../../../../core/app/app-provider.service";


@Injectable()
export class ParamCeRepositoryService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  /**
   * Finds ce's parameter by ce id
   * @param ceId ID of ce that needs to be fetched
   */
  public getParamCeByCeId(ceId: number): Observable<ParamCeInterface> {
    if (ceId === null || ceId === undefined) {
      throw new Error('Required parameter ceId was null or undefined when calling getParamCeByCeId.');
    }

    const url = this.Routing.generate('api_get_param_ce',
      {
        '_format': 'json',
        'ceId': ceId
      }, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        return response.json().data as ParamCeInterface;
      });
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/repository/symfony-api/param-ce-repository.service.ts